/**
 * Global loader utilities - TypeScript replacement for window.Homebase.showPreloader/hidePreloader
 *
 * These functions manipulate the server-rendered preloader element to show/hide a
 * full-page loading overlay.
 */

export const showGlobalLoader = () => {
  const preloader = document.querySelector(
    '.main-wrapper > .preloader-block'
  ) as HTMLElement;
  if (preloader) {
    preloader.style.display = 'block';
    preloader.classList.add('is-shown');
  }
};

export const hideGlobalLoader = () => {
  const preloader = document.querySelector(
    '.main-wrapper > .preloader-block'
  ) as HTMLElement;
  if (preloader) {
    preloader.style.display = 'none';
    preloader.classList.remove('is-shown');
  }
};
